interface StepperItemProps{
  variant?: "active" | "disabled" | "completed" | "section_active" | "section_completed";
  step?: string;
  title?: string;
  size?: number;
  marginBottom?: string;
  borderWidth?: number;
}

const getDescriptionClassName = (variant?: "active" | "disabled" | "completed" | "section_active" | "section_completed") => {
  if(variant === "completed" || variant === "active"){
      return `polymer-stepper-item__description__${variant}`;
  }else{
      return "polymer-stepper-item__description";
  }
}

function StepperItem({size=64,variant="active",borderWidth=2,...props}:StepperItemProps) {
  let stepperSize = size;
  let iconSize = Number(size)/ 1.5;
  let tickColor = variant === "section_completed" ? "#0C8188" : "#FFF";

  const isDisabled = variant === "completed" || variant === "disabled" || variant === "section_completed"

  return (
    <div aria-disabled={isDisabled} className='polymer-stepper-item'>
      <div className={`polymer-stepper-item__icon polymer-stepper-item__icon__${variant}`} style={{width:stepperSize, height:stepperSize,marginBottom: props.marginBottom ?? "0px", borderWidth: `${borderWidth}px`}}>
        {!(variant === "completed" || variant === "section_completed") && <p className={`polymer-stepper-item__icon__text polymer-stepper-item__icon__${variant}-text`}>
          {props.step}
        </p>}
        
        {(variant === "completed" || variant === "section_completed") && <svg width={iconSize} height={iconSize} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.0003 26.9536L8.05026 20.0036L5.68359 22.3536L15.0003 31.6703L35.0003 11.6703L32.6503 9.32031L15.0003 26.9536Z" fill={tickColor}/>
        </svg>}
      </div>
      {props.title && <div className={getDescriptionClassName(variant)}>
        <p>{props.title}</p>
      </div> }
    </div>
  )
}

export default StepperItem